import { getFilters } from "../../utils/commonUtils";
import { commonBaseApiSlice } from "../commonBaseApiSlice";

export const ecwOrderApiSlice = commonBaseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEcwOrders: builder.mutation({
      query: (data: any) => ({
        url: `/ecw/getbyid?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    recordEcwOrder: builder.mutation({
      query: (data) => ({
        url: `/ecw/recordecwdata?tenantId=${data?.recordUsageInfo?.clientId ?? ''}`,
        method: "POST",
        body: data,
      }),
    }),
    getEcwOrderLogs: builder.mutation({
      query: (data: any) => ({
        url: `/ecw/get?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    revertEcwOrder: builder.mutation({
      query: (data: any) => ({
        url: `/ecw/revertecworder?${getFilters(data)}`,
        method: "PATCH",
      }),
    }),
  }),
});


export const {
  useGetEcwOrdersMutation,
  useRecordEcwOrderMutation,
  useGetEcwOrderLogsMutation,
  useRevertEcwOrderMutation,
} = ecwOrderApiSlice;